import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner',
  standalone: false,
  template: `<div class="spinner"></div>`,
})
export class SpinnerComponent {}
